export default "__VITE_ASSET__64585084__"